module.exports = __webpack_public_path__ + "static/media/hourglass.7fa6da1a.svg";